/* tslint:disable */
/* eslint-disable */
/**
 * HASH Internal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import globalAxios from "axios";
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, } from "./common";
// @ts-ignore
import { BASE_PATH, BaseAPI, } from "./base";
export const ExternalServiceMethodRequestProviderNameEnum = {
    Openai: "openai",
    Mapbox: "mapbox",
};
export const ExternalServiceMethodRequestMethodNameEnum = {
    ForwardGeocoding: "forwardGeocoding",
    ReverseGeocoding: "reverseGeocoding",
    RetrieveDirections: "retrieveDirections",
    RetrieveIsochrones: "retrieveIsochrones",
    SuggestAddress: "suggestAddress",
    RetrieveAddress: "retrieveAddress",
    CanRetrieveAddress: "canRetrieveAddress",
    RetrieveStaticMap: "retrieveStaticMap",
    CreateImage: "createImage",
    CompleteText: "completeText",
};
/**
 *
 * @export
 * @enum {string}
 */
export const StatusCode = {
    Ok: "OK",
    Cancelled: "CANCELLED",
    Unknown: "UNKNOWN",
    InvalidArgument: "INVALID_ARGUMENT",
    DeadlineExceeded: "DEADLINE_EXCEEDED",
    NotFound: "NOT_FOUND",
    AlreadyExists: "ALREADY_EXISTS",
    PermissionDenied: "PERMISSION_DENIED",
    Unauthenticated: "UNAUTHENTICATED",
    ResourceExhausted: "RESOURCE_EXHAUSTED",
    FailedPrecondition: "FAILED_PRECONDITION",
    Aborted: "ABORTED",
    OutOfRange: "OUT_OF_RANGE",
    Unimplemented: "UNIMPLEMENTED",
    Internal: "INTERNAL",
    Unavailable: "UNAVAILABLE",
    DataLoss: "DATA_LOSS",
};
/**
 *
 * @export
 * @enum {string}
 */
export const SubscriptionTier = {
    Hobby: "hobby",
    Pro: "pro",
};
/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create a stripe setup intent, for the purpose of adding a new payment method.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStripeSetupIntent: async (options = {}) => {
            const localVarPath = `/stripe-setup-intent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: "POST",
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a subscription
         * @param {CreateSubscriptionRequest} createSubscriptionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscription: async (createSubscriptionRequest, options = {}) => {
            // verify required parameter 'createSubscriptionRequest' is not null or undefined
            assertParamExists("createSubscription", "createSubscriptionRequest", createSubscriptionRequest);
            const localVarPath = `/subscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: "POST",
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(createSubscriptionRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete the tax ID associated with the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTaxId: async (options = {}) => {
            const localVarPath = `/tax-id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: "DELETE",
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Detach an existing payment method from a BP user
         * @param {string} paymentMethodId The payment method ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detachPaymentMethod: async (paymentMethodId, options = {}) => {
            // verify required parameter 'paymentMethodId' is not null or undefined
            assertParamExists("detachPaymentMethod", "paymentMethodId", paymentMethodId);
            const localVarPath = `/payment-method`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: "DELETE",
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (paymentMethodId !== undefined) {
                localVarQueryParameter["paymentMethodId"] = paymentMethodId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Call an external service method
         * @param {ExternalServiceMethodRequest} externalServiceMethodRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalServiceMethod: async (externalServiceMethodRequest, options = {}) => {
            // verify required parameter 'externalServiceMethodRequest' is not null or undefined
            assertParamExists("externalServiceMethod", "externalServiceMethodRequest", externalServiceMethodRequest);
            const localVarPath = `/external-service-method`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: "POST",
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(externalServiceMethodRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all open or paid invoices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoices: async (options = {}) => {
            const localVarPath = `/invoices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve the payment methods of the BP user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentMethods: async (options = {}) => {
            const localVarPath = `/payment-methods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve the subscription of the BP user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscription: async (options = {}) => {
            const localVarPath = `/subscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve the subscription tier prices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionTierPrices: async (options = {}) => {
            const localVarPath = `/subscription-tier-prices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get the tax ID of a user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaxId: async (options = {}) => {
            const localVarPath = `/tax-id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve an upcoming invoice
         * @param {SubscriptionTier} [newSubscriptionTier] Calculate the upcoming invoice based on a new subscription tier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUpcomingInvoice: async (newSubscriptionTier, options = {}) => {
            const localVarPath = `/upcoming-invoice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (newSubscriptionTier !== undefined) {
                localVarQueryParameter["newSubscriptionTier"] = newSubscriptionTier;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Set the tax ID of a user
         * @param {SetTaxIdRequest} setTaxIdRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setTaxId: async (setTaxIdRequest, options = {}) => {
            // verify required parameter 'setTaxIdRequest' is not null or undefined
            assertParamExists("setTaxId", "setTaxIdRequest", setTaxIdRequest);
            const localVarPath = `/tax-id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: "PUT",
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(setTaxIdRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update an existing payment method of the BP user
         * @param {string} paymentMethodId The payment method ID
         * @param {UpdatePaymentMethodRequest} updatePaymentMethodRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePaymentMethod: async (paymentMethodId, updatePaymentMethodRequest, options = {}) => {
            // verify required parameter 'paymentMethodId' is not null or undefined
            assertParamExists("updatePaymentMethod", "paymentMethodId", paymentMethodId);
            // verify required parameter 'updatePaymentMethodRequest' is not null or undefined
            assertParamExists("updatePaymentMethod", "updatePaymentMethodRequest", updatePaymentMethodRequest);
            const localVarPath = `/payment-method`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: "PUT",
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (paymentMethodId !== undefined) {
                localVarQueryParameter["paymentMethodId"] = paymentMethodId;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(updatePaymentMethodRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update the default payment method of an existing subscription
         * @param {UpdateSubscriptionDefaultPaymentMethodRequest} updateSubscriptionDefaultPaymentMethodRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscriptionDefaultPaymentMethod: async (updateSubscriptionDefaultPaymentMethodRequest, options = {}) => {
            // verify required parameter 'updateSubscriptionDefaultPaymentMethodRequest' is not null or undefined
            assertParamExists("updateSubscriptionDefaultPaymentMethod", "updateSubscriptionDefaultPaymentMethodRequest", updateSubscriptionDefaultPaymentMethodRequest);
            const localVarPath = `/subscription-default-payment-method`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: "PUT",
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(updateSubscriptionDefaultPaymentMethodRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update the subscription tier of an existing subscription
         * @param {UpdateSubscriptionTierRequest} updateSubscriptionTierRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscriptionTier: async (updateSubscriptionTierRequest, options = {}) => {
            // verify required parameter 'updateSubscriptionTierRequest' is not null or undefined
            assertParamExists("updateSubscriptionTier", "updateSubscriptionTierRequest", updateSubscriptionTierRequest);
            const localVarPath = `/subscription-tier`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: "PUT",
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(updateSubscriptionTierRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function (configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a stripe setup intent, for the purpose of adding a new payment method.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createStripeSetupIntent(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createStripeSetupIntent(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Create a subscription
         * @param {CreateSubscriptionRequest} createSubscriptionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSubscription(createSubscriptionRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSubscription(createSubscriptionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete the tax ID associated with the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTaxId(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTaxId(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Detach an existing payment method from a BP user
         * @param {string} paymentMethodId The payment method ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async detachPaymentMethod(paymentMethodId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.detachPaymentMethod(paymentMethodId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Call an external service method
         * @param {ExternalServiceMethodRequest} externalServiceMethodRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalServiceMethod(externalServiceMethodRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalServiceMethod(externalServiceMethodRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all open or paid invoices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoices(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoices(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Retrieve the payment methods of the BP user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentMethods(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentMethods(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Retrieve the subscription of the BP user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubscription(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubscription(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Retrieve the subscription tier prices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubscriptionTierPrices(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubscriptionTierPrices(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get the tax ID of a user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTaxId(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTaxId(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Retrieve an upcoming invoice
         * @param {SubscriptionTier} [newSubscriptionTier] Calculate the upcoming invoice based on a new subscription tier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUpcomingInvoice(newSubscriptionTier, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUpcomingInvoice(newSubscriptionTier, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Set the tax ID of a user
         * @param {SetTaxIdRequest} setTaxIdRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setTaxId(setTaxIdRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setTaxId(setTaxIdRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Update an existing payment method of the BP user
         * @param {string} paymentMethodId The payment method ID
         * @param {UpdatePaymentMethodRequest} updatePaymentMethodRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePaymentMethod(paymentMethodId, updatePaymentMethodRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePaymentMethod(paymentMethodId, updatePaymentMethodRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Update the default payment method of an existing subscription
         * @param {UpdateSubscriptionDefaultPaymentMethodRequest} updateSubscriptionDefaultPaymentMethodRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSubscriptionDefaultPaymentMethod(updateSubscriptionDefaultPaymentMethodRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSubscriptionDefaultPaymentMethod(updateSubscriptionDefaultPaymentMethodRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Update the subscription tier of an existing subscription
         * @param {UpdateSubscriptionTierRequest} updateSubscriptionTierRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSubscriptionTier(updateSubscriptionTierRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSubscriptionTier(updateSubscriptionTierRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DefaultApiFp(configuration);
    return {
        /**
         *
         * @summary Create a stripe setup intent, for the purpose of adding a new payment method.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStripeSetupIntent(options) {
            return localVarFp
                .createStripeSetupIntent(options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a subscription
         * @param {CreateSubscriptionRequest} createSubscriptionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscription(createSubscriptionRequest, options) {
            return localVarFp
                .createSubscription(createSubscriptionRequest, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete the tax ID associated with the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTaxId(options) {
            return localVarFp
                .deleteTaxId(options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Detach an existing payment method from a BP user
         * @param {string} paymentMethodId The payment method ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detachPaymentMethod(paymentMethodId, options) {
            return localVarFp
                .detachPaymentMethod(paymentMethodId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Call an external service method
         * @param {ExternalServiceMethodRequest} externalServiceMethodRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalServiceMethod(externalServiceMethodRequest, options) {
            return localVarFp
                .externalServiceMethod(externalServiceMethodRequest, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all open or paid invoices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoices(options) {
            return localVarFp
                .getInvoices(options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve the payment methods of the BP user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentMethods(options) {
            return localVarFp
                .getPaymentMethods(options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve the subscription of the BP user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscription(options) {
            return localVarFp
                .getSubscription(options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve the subscription tier prices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionTierPrices(options) {
            return localVarFp
                .getSubscriptionTierPrices(options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the tax ID of a user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaxId(options) {
            return localVarFp
                .getTaxId(options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve an upcoming invoice
         * @param {SubscriptionTier} [newSubscriptionTier] Calculate the upcoming invoice based on a new subscription tier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUpcomingInvoice(newSubscriptionTier, options) {
            return localVarFp
                .getUpcomingInvoice(newSubscriptionTier, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Set the tax ID of a user
         * @param {SetTaxIdRequest} setTaxIdRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setTaxId(setTaxIdRequest, options) {
            return localVarFp
                .setTaxId(setTaxIdRequest, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update an existing payment method of the BP user
         * @param {string} paymentMethodId The payment method ID
         * @param {UpdatePaymentMethodRequest} updatePaymentMethodRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePaymentMethod(paymentMethodId, updatePaymentMethodRequest, options) {
            return localVarFp
                .updatePaymentMethod(paymentMethodId, updatePaymentMethodRequest, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update the default payment method of an existing subscription
         * @param {UpdateSubscriptionDefaultPaymentMethodRequest} updateSubscriptionDefaultPaymentMethodRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscriptionDefaultPaymentMethod(updateSubscriptionDefaultPaymentMethodRequest, options) {
            return localVarFp
                .updateSubscriptionDefaultPaymentMethod(updateSubscriptionDefaultPaymentMethodRequest, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update the subscription tier of an existing subscription
         * @param {UpdateSubscriptionTierRequest} updateSubscriptionTierRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscriptionTier(updateSubscriptionTierRequest, options) {
            return localVarFp
                .updateSubscriptionTier(updateSubscriptionTierRequest, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     *
     * @summary Create a stripe setup intent, for the purpose of adding a new payment method.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    createStripeSetupIntent(options) {
        return DefaultApiFp(this.configuration)
            .createStripeSetupIntent(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a subscription
     * @param {CreateSubscriptionRequest} createSubscriptionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    createSubscription(createSubscriptionRequest, options) {
        return DefaultApiFp(this.configuration)
            .createSubscription(createSubscriptionRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete the tax ID associated with the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    deleteTaxId(options) {
        return DefaultApiFp(this.configuration)
            .deleteTaxId(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Detach an existing payment method from a BP user
     * @param {string} paymentMethodId The payment method ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    detachPaymentMethod(paymentMethodId, options) {
        return DefaultApiFp(this.configuration)
            .detachPaymentMethod(paymentMethodId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Call an external service method
     * @param {ExternalServiceMethodRequest} externalServiceMethodRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    externalServiceMethod(externalServiceMethodRequest, options) {
        return DefaultApiFp(this.configuration)
            .externalServiceMethod(externalServiceMethodRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all open or paid invoices
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getInvoices(options) {
        return DefaultApiFp(this.configuration)
            .getInvoices(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve the payment methods of the BP user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getPaymentMethods(options) {
        return DefaultApiFp(this.configuration)
            .getPaymentMethods(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve the subscription of the BP user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getSubscription(options) {
        return DefaultApiFp(this.configuration)
            .getSubscription(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve the subscription tier prices
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getSubscriptionTierPrices(options) {
        return DefaultApiFp(this.configuration)
            .getSubscriptionTierPrices(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the tax ID of a user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getTaxId(options) {
        return DefaultApiFp(this.configuration)
            .getTaxId(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve an upcoming invoice
     * @param {SubscriptionTier} [newSubscriptionTier] Calculate the upcoming invoice based on a new subscription tier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getUpcomingInvoice(newSubscriptionTier, options) {
        return DefaultApiFp(this.configuration)
            .getUpcomingInvoice(newSubscriptionTier, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Set the tax ID of a user
     * @param {SetTaxIdRequest} setTaxIdRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    setTaxId(setTaxIdRequest, options) {
        return DefaultApiFp(this.configuration)
            .setTaxId(setTaxIdRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update an existing payment method of the BP user
     * @param {string} paymentMethodId The payment method ID
     * @param {UpdatePaymentMethodRequest} updatePaymentMethodRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    updatePaymentMethod(paymentMethodId, updatePaymentMethodRequest, options) {
        return DefaultApiFp(this.configuration)
            .updatePaymentMethod(paymentMethodId, updatePaymentMethodRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update the default payment method of an existing subscription
     * @param {UpdateSubscriptionDefaultPaymentMethodRequest} updateSubscriptionDefaultPaymentMethodRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    updateSubscriptionDefaultPaymentMethod(updateSubscriptionDefaultPaymentMethodRequest, options) {
        return DefaultApiFp(this.configuration)
            .updateSubscriptionDefaultPaymentMethod(updateSubscriptionDefaultPaymentMethodRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update the subscription tier of an existing subscription
     * @param {UpdateSubscriptionTierRequest} updateSubscriptionTierRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    updateSubscriptionTier(updateSubscriptionTierRequest, options) {
        return DefaultApiFp(this.configuration)
            .updateSubscriptionTier(updateSubscriptionTierRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
//# sourceMappingURL=api.js.map